import './style_privicy.css';
import Navbar from '../../Navbar/Navbar';
import Footer from '../Footer';
import { useEffect, useState } from 'react';
import Loading from '../../Loading/Loading';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../../Firebase/firebase';

function Privicy() {
    const [myData, setMyData] = useState([]);
    //console.log(myData);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(()=> {

        const fetchData = async()=> {

            const getMyData = await getDocs(collection(db, 'myPrivicy'));
            const dataList = getMyData.docs.map((e)=> ({
                ...e.data(),
                id: e.id,
            }));

            console.log(getMyData);
            

            // ترتيب البيانات من الأقدم إلى الأحدث بناءً على Timestamp
            dataList.sort((a, b) => {
                return a.TimeStamp.toDate() - b.TimeStamp.toDate();
            });

            setMyData(dataList);

            setIsLoading(false);
        };

        fetchData();
    }, []);

    if(isLoading) {
        return(
            <Loading />
        )

    } else {
        return (
            <>
                <div className='my-privicy'>
                    <div className='container'>
                        <Navbar />
    
                        <div className='hero'>
                            <h1>سياسة الخصوصية</h1>
                            <hr />
                        </div>
    
                        <div className='content'>
                            <div className='head'>
                                <span></span>
                                <h1>
                                     يرجى قراءة سياسة الخصوصية هذه بعناية تامة عند استخدام موقع توت
                                </h1>
                                <span></span>
                            </div>
                        </div>

                        {
                            myData.map((e)=> {
                                return(
                                    <div className='my-details' key={e.id}>
                                        <details>
                                            <summary>{e.title}</summary>
                                            {/* <p>
                                                {e.content}
                                            </p> */}

                                    {
                                        myData.length > 0 && (
                                            <div key={myData.id}>
                                                {
                                                    e.content.split('\n').map((line, index) => (
                                                        <p key={index} style={{ fontWeight: index % 2 === 0 ? 'normal' : 'normal' }}>
                                                            {line}
                                                        </p>
                                                    ))
                                                }
                                            </div>
                                        )
                                    }
                                        </details>
                                    </div>
                                )
                            })
                        }
    
                        <Footer />
                    </div>
                </div>
            </>
        );
    }

};


export default Privicy;